<template><div><h2 id="all-corners" tabindex="-1" class="d-docsite--header-2">All Corners <a class="header-anchor d-link d-docsite--link d-link" href="#all-corners" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bar-{stop}</code> to change the border radius on all four corners. The stop references the matching <code v-pre>--dt-size-radius-{stop}</code> token.</p>
<code-example source-code='&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-0&quot;&gt;  &lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-0&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-100&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-100&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-200&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-200&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-300&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-300&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-350&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-350&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-400&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-400&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-450&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-450&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-500&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-500&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-550&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-550&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-600&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-600&lt;/dt-text&gt;&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="100" direction="row" justify="center" class="d-fw-wrap">
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-0">  <dt-text kind="code" size="xs">d-bar-0</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-100"><dt-text kind="code" size="xs">d-bar-100</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-200"><dt-text kind="code" size="xs">d-bar-200</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-300"><dt-text kind="code" size="xs">d-bar-300</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-350"><dt-text kind="code" size="xs">d-bar-350</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-400"><dt-text kind="code" size="xs">d-bar-400</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-450"><dt-text kind="code" size="xs">d-bar-450</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-500"><dt-text kind="code" size="xs">d-bar-500</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-550"><dt-text kind="code" size="xs">d-bar-550</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-600"><dt-text kind="code" size="xs">d-bar-600</dt-text></div>
</dt-stack>
</code-example>
<h2 id="rounded-sides" tabindex="-1" class="d-docsite--header-2">Rounded Sides <a class="header-anchor d-link d-docsite--link d-link" href="#rounded-sides" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use a side-pair class to round the two corners on a single side. Class roots are the first-letter compression of the matching CSS logical property.</p>
<table>
<thead>
<tr>
<th>Class root</th>
<th>CSS properties set</th>
<th>Visible in LTR</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>d-bbsr-*</code></td>
<td><code v-pre>border-start-start-radius</code> + <code v-pre>border-start-end-radius</code></td>
<td>top</td>
</tr>
<tr>
<td><code v-pre>d-bier-*</code></td>
<td><code v-pre>border-start-end-radius</code> + <code v-pre>border-end-end-radius</code></td>
<td>right</td>
</tr>
<tr>
<td><code v-pre>d-bber-*</code></td>
<td><code v-pre>border-end-start-radius</code> + <code v-pre>border-end-end-radius</code></td>
<td>bottom</td>
</tr>
<tr>
<td><code v-pre>d-bisr-*</code></td>
<td><code v-pre>border-start-start-radius</code> + <code v-pre>border-end-start-radius</code></td>
<td>left</td>
</tr>
</tbody>
</table>
<code-example source-code='&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bbsr-450&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bbsr-450&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bier-450&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bier-450&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bber-450&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bber-450&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bisr-450&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bisr-450&lt;/dt-text&gt;&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="100" direction="row" justify="center" class="d-fw-wrap">
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bbsr-450"><dt-text kind="code" size="xs">d-bbsr-450</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bier-450"><dt-text kind="code" size="xs">d-bier-450</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bber-450"><dt-text kind="code" size="xs">d-bber-450</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bisr-450"><dt-text kind="code" size="xs">d-bisr-450</dt-text></div>
</dt-stack>
</code-example>
<h2 id="individual-corners" tabindex="-1" class="d-docsite--header-2">Individual Corners <a class="header-anchor d-link d-docsite--link d-link" href="#individual-corners" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use a single-corner class to round exactly one corner. Class roots match the CSS logical corner properties.</p>
<table>
<thead>
<tr>
<th>Class root</th>
<th>CSS property set</th>
<th>Visible in LTR</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>d-bssr-*</code></td>
<td><code v-pre>border-start-start-radius</code></td>
<td>top-left</td>
</tr>
<tr>
<td><code v-pre>d-bser-*</code></td>
<td><code v-pre>border-start-end-radius</code></td>
<td>top-right</td>
</tr>
<tr>
<td><code v-pre>d-beer-*</code></td>
<td><code v-pre>border-end-end-radius</code></td>
<td>bottom-right</td>
</tr>
<tr>
<td><code v-pre>d-besr-*</code></td>
<td><code v-pre>border-end-start-radius</code></td>
<td>bottom-left</td>
</tr>
</tbody>
</table>
<code-example source-code='&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bssr-500&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bssr-500&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bser-500&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bser-500&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-beer-500&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-beer-500&lt;/dt-text&gt;&lt;/div&gt;
&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-besr-500&quot;&gt;&lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-besr-500&lt;/dt-text&gt;&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="100" direction="row" justify="center" class="d-fw-wrap">
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bssr-500"><dt-text kind="code" size="xs">d-bssr-500</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bser-500"><dt-text kind="code" size="xs">d-bser-500</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-beer-500"><dt-text kind="code" size="xs">d-beer-500</dt-text></div>
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-besr-500"><dt-text kind="code" size="xs">d-besr-500</dt-text></div>
</dt-stack>
</code-example>
<h2 id="pills" tabindex="-1" class="d-docsite--header-2">Pills <a class="header-anchor d-link d-docsite--link d-link" href="#pills" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bar-pill</code> for a pill-shaped radius on all four corners. The same <code v-pre>-pill</code> suffix is available on every scope (<code v-pre>d-bbsr-pill</code>, <code v-pre>d-bssr-pill</code>, etc.).</p>
<code-example source-code='&lt;div class=&quot;d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-pill&quot;&gt;
  &lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-pill&lt;/dt-text&gt;
&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="100" direction="row" justify="center" class="d-fw-wrap">
  <div class="d-p-100 d-ba d-baw2 d-bgc-primary d-ws-nowrap d-bar-pill">
    <dt-text kind="code" size="xs">d-bar-pill</dt-text>
  </div>
</dt-stack>
</code-example>
<h2 id="circles" tabindex="-1" class="d-docsite--header-2">Circles <a class="header-anchor d-link d-docsite--link d-link" href="#circles" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bar-circle</code> for a fully circular radius. Best paired with a square element.</p>
<code-example source-code='&lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-100 d-size-200 d-ba d-baw2 d-bc-default d-bgc-primary d-ws-nowrap d-bar-circle&quot;&gt;
  &lt;dt-text kind=&quot;code&quot; size=&quot;xs&quot;&gt;d-bar-circle&lt;/dt-text&gt;
&lt;/dt-stack&gt;'>
<dt-stack data-demo-wrapper gap="100" direction="row" justify="center" class="d-fw-wrap">
  <dt-stack direction="row" align="center" justify="center" class="d-p-100 d-size-200 d-ba d-baw2 d-bc-default d-bgc-primary d-ws-nowrap d-bar-circle">
    <dt-text kind="code" size="xs">d-bar-circle</dt-text>
  </dt-stack>
</dt-stack>
</code-example>
<h2 id="reset" tabindex="-1" class="d-docsite--header-2">Reset <a class="header-anchor d-link d-docsite--link d-link" href="#reset" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bar-unset</code> to reset the border-radius on all four corners to <code v-pre>unset</code>.</p>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table show-rendered>
  <template #content>
    <tbody v-for="scope in radius.scopes" :key="scope.logicalPrefix">
      <tr v-for="val in radius.values" :key="`${scope.logicalPrefix}-${val.stop}`">
        <th scope="row">
          <dt-text as="span" kind="code" :size="100" class="d-docsite-code">.d-{{ scope.logicalPrefix }}-{{ val.stop }}</dt-text>
        </th>
        <td class="d-code--sm">
          <span v-for="prop in scope.cssProperties" :key="prop">
            {{ prop }}: var(--dt-size-radius-{{ val.stop }}) !important;<br/>
          </span>
        </td>
        <td class="d-code--sm d-fc-tertiary d-ta-right">{{ val.rem }}</td>
        <td class="d-code--sm d-fc-tertiary d-ta-right">{{ val.px }}</td>
      </tr>
      <template v-if="scope.legacyPrefix">
        <tr v-for="val in radius.values.filter(v => hasDistinctLegacy(scope, v))" :key="`legacy-${scope.legacyPrefix}-${val.legacyPx}`">
          <th scope="row">
            <dt-stack gap="50">
              <dt-text as="span" kind="code" :size="100" class="d-docsite-code">
                .d-{{ scope.legacyPrefix }}<template v-if="val.legacyPx === 'pill' || val.legacyPx === 'circle'">-</template>{{ val.legacyPx }}
              </dt-text>
              <dt-badge type="critical" kind="label" text="Deprecated" />
            </dt-stack>
          </th>
          <td class="d-code--sm">
            <span v-for="prop in scope.cssProperties" :key="prop">
              {{ prop }}: var(--dt-size-radius-{{ val.stop }}) !important;<br/>
            </span>
          </td>
          <td class="d-code--sm d-fc-tertiary d-ta-right">{{ val.rem }}</td>
          <td class="d-code--sm d-fc-tertiary d-ta-right">{{ val.px }}</td>
        </tr>
      </template>
    </tbody>
    <tbody>
      <tr>
        <th scope="row">
          <dt-text as="span" kind="code" :size="100" class="d-docsite-code">.d-bar-unset</dt-text>
        </th>
        <td class="d-code--sm">border-radius: unset !important;</td>
        <td class="d-fc-muted d-fs-100 d-ta-center">N/A</td>
        <td class="d-fc-muted d-fs-100 d-ta-center">N/A</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { radius } from '@data/borders.json';

  // Skip legacy rows when the constructed class equals the logical one (e.g. .d-bar-pill,
  // .d-bar-circle where legacyPrefix == logicalPrefix and legacyPx is the keyword).
  function hasDistinctLegacy (scope, val) {
    if (val.legacyPx == null) return false;
    const infix = (val.legacyPx === 'pill' || val.legacyPx === 'circle') ? '-' : '';
    const legacyClass = `d-${scope.legacyPrefix}${infix}${val.legacyPx}`;
    const logicalClass = `d-${scope.logicalPrefix}-${val.stop}`;
    return legacyClass !== logicalClass;
  }
</script>